"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof3 = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _ykbStyledComponents = _interopRequireWildcard(require("../ykb-styled-components"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _draggable = _interopRequireDefault(require("./draggable"));
var _reactDnd = require("react-dnd");
var _reactDndHtml5Backend = require("react-dnd-html5-backend");
var _styled = require("./draggable/styled.js");
var _DragIcons = require("./draggable/DragIcons");
var _ykbUtils = require("ykb-utils");
var _excluded = ["draggable", "columns", "title", "data"],
  _excluded2 = ["index", "moveRow", "className", "style"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof3(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var type = 'DragableBodyRow';
var Wrapper = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-1j81zlw-0"
})([""]);
var noob = function noob() {};
var _findStartIndex = function findStartIndex(columns) {
  var _columns$index, _columns$index$dragga;
  var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  if (((_columns$index = columns[index]) === null || _columns$index === void 0 ? void 0 : (_columns$index$dragga = _columns$index.draggableProps) === null || _columns$index$dragga === void 0 ? void 0 : _columns$index$dragga.draggable) === false) {
    return _findStartIndex(columns, index + 1);
  }
  return index;
};
var _findEndDragIndex = function findEndDragIndex(columns, index) {
  var _columns$index2, _columns$index2$dragg;
  if (((_columns$index2 = columns[index]) === null || _columns$index2 === void 0 ? void 0 : (_columns$index2$dragg = _columns$index2.draggableProps) === null || _columns$index2$dragg === void 0 ? void 0 : _columns$index2$dragg.draggable) === false) {
    return _findEndDragIndex(columns, index - 1);
  }
  return index;
};
var _findEndActionIndex = function findEndActionIndex(columns, index) {
  var _columns$index3, _columns$index3$type;
  // prevent move forward to action buttons
  if ((_columns$index3 = columns[index]) !== null && _columns$index3 !== void 0 && (_columns$index3$type = _columns$index3.type) !== null && _columns$index3$type !== void 0 && _columns$index3$type.action) {
    return _findEndActionIndex(columns, index - 1);
  }
  return index;
};
var findEndIndex = function findEndIndex(columns) {
  var endActionIndex = _findEndActionIndex(columns, columns.length - 1);
  return _findEndDragIndex(columns, endActionIndex);
};
var enhance = function enhance(Table) {
  return function (_ref) {
    var _ref$draggable = _ref.draggable,
      draggable = _ref$draggable === void 0 ? {} : _ref$draggable,
      columns = _ref.columns,
      title = _ref.title,
      data = _ref.data,
      rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
    /*
      columns: default and initial state of columns
      columnsBeforeEditting: state of columns when editting mode turns true
      columnsOrdered: final state of columns
    */
    var _draggable$draggableC = draggable.draggableColumn,
      draggableColumn = _draggable$draggableC === void 0 ? false : _draggable$draggableC,
      _draggable$draggableR = draggable.draggableRow,
      draggableRow = _draggable$draggableR === void 0 ? false : _draggable$draggableR,
      hideColumnIcon = draggable.hideColumnIcon,
      hideRowIcon = draggable.hideRowIcon,
      showRowNumber = draggable.showRowNumber,
      editable = draggable.editable,
      editting = draggable.editting,
      onReset = draggable.onReset,
      onSave = draggable.onSave,
      onCancel = draggable.onCancel,
      onDelete = draggable.onDelete,
      _draggable$setColumns = draggable.setColumns,
      setColumns = _draggable$setColumns === void 0 ? function () {} : _draggable$setColumns,
      _draggable$setData = draggable.setData,
      setData = _draggable$setData === void 0 ? function () {} : _draggable$setData;
    var _useState = (0, _react.useState)([]),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      columnsBeforeEditting = _useState2[0],
      setColumnsBeforeEditting = _useState2[1];
    var _useState3 = (0, _react.useState)(columns),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      columnsOrdered = _useState4[0],
      setColumnsOrdered = _useState4[1];
    var _useState5 = (0, _react.useState)([]),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      dataBeforeEditting = _useState6[0],
      setDataBeforeEditting = _useState6[1];
    var _useState7 = (0, _react.useState)(data),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      dataOrdered = _useState8[0],
      setDataOrdered = _useState8[1];
    var isRowDraggable = function isRowDraggable() {
      return !!draggableRow && (!editable || editable && editting);
    };
    var isColumnDraggable = function isColumnDraggable() {
      return !!draggableColumn && (!editable || editable && editting);
    };
    var _useState9 = (0, _react.useState)(),
      _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
      dragStartColIndex = _useState10[0],
      setDragStartColIndex = _useState10[1];
    var _useState11 = (0, _react.useState)(),
      _useState12 = (0, _slicedToArray2.default)(_useState11, 2),
      dragEndColIndex = _useState12[0],
      setDragEndColIndex = _useState12[1];
    (0, _react.useEffect)(function () {
      if (!!draggableRow) {
        setDataOrdered(data);
      }
    }, [data]);
    (0, _react.useEffect)(function () {
      if (editting) {
        setDataBeforeEditting(dataOrdered);
        setColumnsBeforeEditting(columnsOrdered);
        if (Array.isArray(columnsOrdered)) {
          var startIndex = _findStartIndex(columnsOrdered);
          setDragStartColIndex(startIndex);
          var endIndex = findEndIndex(columnsOrdered);
          setDragEndColIndex(endIndex);
        }
      }
    }, [editting]);
    (0, _react.useEffect)(function () {
      if (!!draggableColumn) {
        setColumnsOrdered(columns);
        if (Array.isArray(columns)) {
          var startIndex = _findStartIndex(columns);
          setDragStartColIndex(startIndex);
          var endIndex = findEndIndex(columns);
          setDragEndColIndex(endIndex);
        }
      }
    }, [columns]);
    var renderTitle = title;
    if (typeof renderTitle !== 'function' && !(0, _ykbUtils.isNullOrUndefined)(title)) {
      renderTitle = function renderTitle() {
        return title;
      };
    }
    var columnDragProps = {
      reorderByIndexes: function reorderByIndexes(fromIndex, toIndex) {
        var extraCol = 0;
        if (showRowNumber) extraCol++;
        if (!hideRowIcon) extraCol++;
        // Ekstra td varsa (expandable ve rowSelection),
        // drag ve drop üzerinde ki indexlerde 1'er artış olması gerekiyor ki, drag ve drop yapılan td indexleri (expandable ve rowselection) alanlarını hesaplamasın.
        if ((0, _typeof2.default)(rest.rowSelection) == 'object') extraCol++;
        if (typeof rest.expandedRowRender == 'function') extraCol++;
        fromIndex -= extraCol;
        toIndex -= extraCol;
        if (toIndex < dragStartColIndex) toIndex = dragStartColIndex;
        if (toIndex > dragEndColIndex) toIndex = dragEndColIndex;
        var newOrder = (0, _toConsumableArray2.default)(columnsOrdered);
        var item = newOrder.splice(fromIndex, 1)[0];
        newOrder.splice(toIndex, 0, item);
        setColumnsOrdered((0, _toConsumableArray2.default)(newOrder));
        setColumns(newOrder);
      },
      nodeSelector: 'th',
      handleSelector: '.dragHandler',
      onDragStart: draggableColumn.onDragStart || noob,
      onDragEnd: draggableColumn.onDragEnd || noob,
      onDragEnter: draggableColumn.onDragEnter || noob,
      onDrop: draggableColumn.onDrop || noob,
      scroll: rest.scroll
    };
    function handleCancel() {
      setColumnsOrdered(columnsBeforeEditting);
      setDataOrdered(dataBeforeEditting);
      onCancel(columnsBeforeEditting, dataBeforeEditting);
    }
    function handleReset() {
      setColumnsOrdered(columns);
      setDataOrdered(data);
      onReset(columns, data);
    }
    function handleSave() {
      onSave(columnsOrdered, dataOrdered);
    }
    function handleDelete(dataIndex) {
      var columns = (0, _toConsumableArray2.default)(columnsOrdered);
      var columnsFiltered = columns.filter(function (element) {
        return element.dataIndex !== dataIndex;
      });
      setColumnsOrdered(columnsFiltered);
      onDelete(columnsFiltered);
      if (Array.isArray(columnsFiltered)) {
        var startIndex = _findStartIndex(columnsFiltered);
        setDragStartColIndex(startIndex);
        var endIndex = findEndIndex(columnsFiltered);
        setDragEndColIndex(endIndex);
      }
    }
    var columnActions = {
      onDelete: function onDelete(_ref2) {
        var _ref2$column = _ref2.column,
          column = _ref2$column === void 0 ? {} : _ref2$column;
        var dataIndex = column.dataIndex,
          draggableProps = column.draggableProps;
        var deletable = !(draggableProps && draggableProps.deletable === false);
        return deletable && /*#__PURE__*/_react.default.createElement(_DragIcons.DragColActionIcon, {
          onClick: function onClick() {
            return handleDelete(dataIndex);
          }
        }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
          name: 'trash',
          size: 18
        }));
      }
    };
    function DragColAction(props) {
      var action = props.action,
        column = props.column;
      return action && columnActions[action.name]({
        column: column
      }) || null;
    }
    function renderColumns() {
      if (isColumnDraggable()) {
        var newColumns = (0, _toConsumableArray2.default)(columnsOrdered).map(function (item, index) {
          var columnWithIcon = _objectSpread({}, item);
          var isDraggableStart = index >= dragStartColIndex;
          var isDraggableEnd = index <= dragEndColIndex;
          var isDraggable = isDraggableStart && isDraggableEnd;
          var dragIcon = !hideColumnIcon && isDraggable && (0, _DragIcons.DragColIcon)();
          var deleteAction = DragColAction({
            action: onDelete,
            column: item
          });
          var iconWidth = rest.theme.table.draggable.column.icon.width;
          var leftIconWidth = dragIcon && iconWidth || 0;
          var rightIconWidth = deleteAction && iconWidth || 0;
          columnWithIcon.title = /*#__PURE__*/_react.default.createElement(Wrapper, {
            theme: rest.theme
          }, dragIcon, /*#__PURE__*/_react.default.createElement(_DragIcons.DragColTitle, {
            $marginLeft: leftIconWidth,
            $marginRight: rightIconWidth
          }, columnWithIcon.title), editable && editting && /*#__PURE__*/_react.default.createElement(_DragIcons.DragColActionWrapper, null, deleteAction));
          return columnWithIcon;
        });
        if (showRowNumber) {
          newColumns = [{
            title: '',
            render: _DragIcons.DragRowNumber,
            width: '40px'
          }].concat((0, _toConsumableArray2.default)(newColumns));
        }
        if (!hideRowIcon) {
          newColumns = [{
            title: '',
            render: function render() {
              return /*#__PURE__*/_react.default.createElement(_DragIcons.DragRowIcon, null);
            },
            width: '40px'
          }].concat((0, _toConsumableArray2.default)(newColumns));
        }
        return newColumns;
      } else {
        return columnsOrdered;
      }
    }
    var DragableBodyRow = function DragableBodyRow(_ref3) {
      var index = _ref3.index,
        moveRow = _ref3.moveRow,
        className = _ref3.className,
        style = _ref3.style,
        restProps = (0, _objectWithoutProperties2.default)(_ref3, _excluded2);
      var ref = (0, _react.useRef)();
      var _useDrop = (0, _reactDnd.useDrop)({
          accept: type,
          collect: function collect(monitor) {
            var _ref4 = monitor.getItem() || {},
              dragIndex = _ref4.index;
            if (dragIndex === index) {
              return {};
            }
            return {
              isOver: monitor.isOver(),
              dropClassName: dragIndex < index ? ' drop-over-downward' : ' drop-over-upward'
            };
          },
          drop: function drop(item) {
            moveRow(item.index, index);
            if (typeof draggableRow.onDrop == 'function') {
              draggableRow.onDrop(item.index, index);
            }
          }
        }),
        _useDrop2 = (0, _slicedToArray2.default)(_useDrop, 2),
        _useDrop2$ = _useDrop2[0],
        isOver = _useDrop2$.isOver,
        dropClassName = _useDrop2$.dropClassName,
        drop = _useDrop2[1];
      var _useDrag = (0, _reactDnd.useDrag)({
          item: {
            type: type,
            index: index
          },
          collect: function collect(monitor) {
            return {
              isDragging: monitor.isDragging()
            };
          },
          begin: function begin() {
            if (typeof draggableRow.onDragStart == 'function') {
              draggableRow.onDragStart(index);
            }
          },
          end: function end() {
            if (typeof draggableRow.onDragEnd == 'function') {
              draggableRow.onDragEnd(index);
            }
          }
        }),
        _useDrag2 = (0, _slicedToArray2.default)(_useDrag, 2),
        drag = _useDrag2[1];
      drop(drag(ref));
      return /*#__PURE__*/_react.default.createElement("tr", (0, _extends2.default)({
        ref: ref,
        className: "".concat(className).concat(isOver ? dropClassName : ''),
        onDragEnter: function onDragEnter() {
          if (typeof draggableRow.onDragEnter == 'function') {
            draggableRow.onDragEnter(index);
          }
        },
        style: _objectSpread({
          cursor: 'move'
        }, style)
      }, restProps));
    };
    var moveRow = (0, _react.useCallback)(function (dragIndex, hoverIndex) {
      var newOrder = (0, _toConsumableArray2.default)(dataOrdered);
      var item = newOrder.splice(dragIndex, 1)[0];
      newOrder.splice(hoverIndex, 0, item);
      setDataOrdered((0, _toConsumableArray2.default)(newOrder));
      setData(newOrder);
    }, [dataOrdered]);
    if (!!draggableRow || !!draggableColumn) {
      var tableHeader = editable && editting ? function () {
        return [renderTitle(), /*#__PURE__*/_react.default.createElement(_styled.StyledDragEditContainer, null, /*#__PURE__*/_react.default.createElement("div", null, onReset && /*#__PURE__*/_react.default.createElement(_styled.DragEditButton, {
          icon: "arrow-left",
          onClick: handleReset
        }, "\u0130lk G\xF6r\xFCn\xFCme D\xF6n")), /*#__PURE__*/_react.default.createElement("div", null, onSave && /*#__PURE__*/_react.default.createElement(_styled.DragEditButton, {
          icon: "check",
          $noMargin: true,
          onClick: handleSave
        }, "Kaydet"), onCancel && /*#__PURE__*/_react.default.createElement(_styled.DragEditButton, {
          icon: "close-alt",
          $noMargin: true,
          onClick: handleCancel
        }, "\u0130ptal Et")))];
      } : renderTitle;
      var onRow = isRowDraggable() ? function (record, index) {
        return {
          index: index,
          moveRow: moveRow
        };
      } : rest.onRow;
      var components = isRowDraggable() ? {
        body: {
          row: DragableBodyRow
        }
      } : rest.components;
      return /*#__PURE__*/_react.default.createElement(_draggable.default.DragColumn, columnDragProps, /*#__PURE__*/_react.default.createElement(_reactDnd.DndProvider, {
        backend: _reactDndHtml5Backend.HTML5Backend
      }, /*#__PURE__*/_react.default.createElement(Table, (0, _extends2.default)({}, rest, {
        draggable: draggable,
        data: dataOrdered,
        columns: renderColumns(),
        title: tableHeader,
        onRow: onRow,
        components: components
      }))));
    } else {
      return /*#__PURE__*/_react.default.createElement(Table, (0, _extends2.default)({
        columns: columns,
        title: renderTitle,
        data: data
      }, rest));
    }
  };
};
var _default = exports.default = enhance;